// extracted by mini-css-extract-plugin
module.exports = {"options":"Setup_options__xRh-7"};